<template>
  <component
    :is="component(content)"
    v-bind="content.props"
    :id="content.slug"
    :class="content.class"
  >
    {{ content.text }}
    <template v-for="(slot, key) in slotContent(content)" #[key] :key="key">
      <RecursiveContent
        v-for="(childContent, childIndex) in slot"
        :key="childIndex"
        :content="childContent"
      />
    </template>
    <template v-if="content.children">
      <RecursiveContent
        v-for="(childContent, childIndex) in content.children"
        :key="childIndex"
        :content="childContent"
      />
    </template>
  </component>
</template>

<script>
import { defineAsyncComponent } from "vue";

export default {
  name: "RecursiveContent",
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  methods: {
    component(content) {
      if (content.tag) {
        return content.tag;
      }
      return defineAsyncComponent(() =>
        import(
          /* webpackChunkName: "[request]" */ `@/components/${content.component}.vue`
        )
      );
    },
    slotContent(item) {
      return item.slot || {};
    },
  },
};
</script>
